import { checkInDetailQueryOptions } from '@/api/queries/activity';
import { KeyboardAwareScreenScroll } from '@/components/layout/keyboard-aware-screen-scroll';
import { QueryState } from '@/components/layout/query-state';
import { ScreenHeader } from '@/components/layout/screen-header';
import { PageTitle } from '@/components/seo/page-title';
import { ActivityCard } from '@/features/activity/components/activity-card';
import { useLikeCheckIn } from '@/features/activity/hooks/use-like-check-in';
import { useQuery } from '@tanstack/react-query';
import { useLocalSearchParams } from 'expo-router';
import { View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

export default function CheckInDetailScreen() {
  const { id } = useLocalSearchParams<{ id: string }>();
  const { toggleLike } = useLikeCheckIn();

  const {
    data: feedItem,
    isLoading,
    error,
    refetch,
  } = useQuery(checkInDetailQueryOptions(id || ''));

  return (
    <QueryState
      isLoading={isLoading}
      error={error}
      onRetry={() => refetch()}
      loadingMessage="Loading check-in..."
      fullScreen={false}
    >
      {feedItem && (
        <SafeAreaView className="flex-1" edges={['top']}>
          <PageTitle title={feedItem.menuItem.name || 'Check-in'} />
          <ScreenHeader title="Check-in" showBackButton />

          <KeyboardAwareScreenScroll>
            <View className="px-4 pt-4 pb-8">
              <ActivityCard item={feedItem} onLike={toggleLike} />
            </View>
          </KeyboardAwareScreenScroll>
        </SafeAreaView>
      )}
    </QueryState>
  );
}
